if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"subPackages","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(4(376|548|647)|5(118|331|473)|2790|6126|8497)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}